export const DATE_TEST_ID = 'issue-field-date.ui.issue-field-date';
export const DATE_TEST_ID_WITH_INLINE_EDIT = 'issue-field-date.ui.issue-field-date--container';
export const DATE_READ_ONLY_TEST_ID_WITH_INLINE_EDIT =
	'issue-field-date.ui.issue-field-date--read-only-container';
export const DATE_READ_VIEW_TEST_ID = 'issue-field-date.ui.issue-field-date-read-view';
export const DEFAULT_WEEK_START_DAY = 0; // Sunday
